import topHeader from '../../components/common/topHeader.vue';
import bottomFoot from '../../components/common/bottomFoot.vue';
import aboutTab from '../../components/about/aboutTab.vue';
import honorMedal from '../../components/about/honorMedal.vue';
import { Sticky } from 'vant';
import common from "@/assets/js/common";
export default {
  components: {
    topHeader,
    bottomFoot,
    aboutTab,
    honorMedal,
    [Sticky.name]: Sticky
  },
  data() {
    return {
      scenario: 'aboutHonor',
      postData: {
        flag: 'about_honor',
        pagesize: 9
      },
      data: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      common.http('/www/home/qiyead', this.postData, res => {
        this.data = res.list.data;
      });
    }
  }
};